module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_theboms.1384638255828eb4e006a0c90e4001dc.png";